import { MoveLeft } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const DetailsPageTitle = ({ title, isBackBtn = true }) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };
  return (
    <div className="details_page_title d-flex gap-2">
      {isBackBtn && <MoveLeft className="c_p" onClick={goBack} />}
      <h1 className="main_title">{title}</h1>
    </div>
  );
};

export default DetailsPageTitle;
